import { doc, getDocFromServer } from 'firebase/firestore';
import { auth, db, functions, httpsCallable } from '@/firebase';
import { createMentionIssuanceId, deterministicMentionId } from './utils/mentionIdentity';

const fields = ['schoolId', 'studentId', 'studentName', 'classId', 'className', 'issuanceId',
  'offence', 'offenseId', 'offenseCategory', 'offenseCategoryId', 'level', 'mentionType', 'mentionTypeId',
  'notes', 'subjectId', 'subject', 'subjectProvenance', 'incidentId', 'attachments'];

/** Replace only persistence; the existing web caller continues its rule pass. */
export async function recordBehaviourMention(data, expectedId) {
  if (!auth.currentUser || data.issuedById !== auth.currentUser.uid) throw new Error('Sign in as the recorder before retrying.');
  data.issuanceId ||= createMentionIssuanceId();
  const id = deterministicMentionId(data);
  if (expectedId && id !== expectedId) throw new Error('The Mention recording identity changed. Retry the original recording.');
  const request = Object.fromEntries(fields.filter(key => data[key] !== undefined).map(key => [key, data[key]]));
  const incident = data.issuedAt?.toDate?.() || data.issuedAt;
  if (incident != null) request.issuedAt = new Date(incident).toISOString();
  const { data: receipt } = await httpsCallable(functions, 'recordBehaviourMention')(request);
  if (receipt.id !== id || receipt.collection !== 'mentions') throw new Error('The saved Mention identity changed. Retry the original recording.');
  const saved = await getDocFromServer(doc(db, 'schools', data.schoolId, 'mentions', id));
  if (!saved.exists()) throw new Error('The saved Mention could not be read. Retry the original recording.');
  return { ...saved.data(), id, wasCreated: receipt.wasCreated };
}
